import { env } from "@src/utils"

export const api = {
  baseUrl:
    env === "production"
      ? "https://itsmybike.cloud/api/web/v1"
      : env === "local"
        ? "http://localhost:4000/api/web/v1"
        : "https://itsmybike-staging.cloud/api/web/v1",
  iLockItUrl: "https://ilockit-key-hub-a0d3b611429d.herokuapp.com",
} as const
